import { requestApi } from 'utils';

export const getInsuranceCompanyBySlugApiRequest = ({ slug }) =>
  requestApi.query(
    `query InsuranceCompanies($slug: String!) {
    insuranceCompanies(slug: $slug) {
      id
      name
      supportEmail
      cooperationLogo
      cooperationLogoHover
      cooperationPartner
      slug
      content {
        headerHeadline
        headerSubline      
      }
      zppCourseOffers {
        id
        courseTitle
        slug
        offerId
        content {
          formFieldsAvailable
          formFieldsRequired
          additionalConsentChecks
          courseinfoChecklist
          bonusDurationText
          courseinfoDescription
          courseinfoHeadline
          courseinfoIllustrationUrl
          headerHeadline
          headerLogoUrl
          headerSubline
          howtoHeadline
          howtoText1
          howtoText2
          howtoText3
        }
      }
    }
  }
`,
    { slug }
  );
